import 'fym-common/src/utils/windowGlobal';
import React from 'react';
import { enableMapSet } from 'immer';
// Needs to be on top of this file
import './IntlInit';
import { TypedMemo } from '../../common/types';
import { AppInitialEntry } from './AppInitialEntry';
import { NativeAuthTokenHandoff } from './NativeAuthTokenHandoff';
import { SessionTokenRefresher } from './SessionTokenRefresher';
import { LoginAsGate } from '../loginAs/LoginAsGate';
import { SignedInHintSync } from '../session/SignedInHintSync';
import { AppIntlProvider } from '../locale/AppIntlProvider';
import { UserLocaleSync } from '../locale/UserLocaleSync';
import { ReduxLoader } from './ReduxLoader';
import { AppRender } from './AppRender';
import { GlobalErrorBoundaryHandler } from '../../errorBoundary/GlobalErrorBoundaryHandler';
import { UniversalAnalytics } from '../../analytics/universal';
import { IsOnlineProvider } from '../../../routing/offlineNotification/views/IsOnlineProvider';
import { TRPCLoader } from './TRPCLoader';
import { TRPCDevTools } from '../../../trpc/TRPCDevTools';
import { Toasts } from '../../common/components/Toasts/Toasts';
import { RealtimeProvider } from '../../realtime/RealtimeProvider';
import { AppUpdateNotice } from '../../appUpdate/AppUpdateNotice';

enableMapSet();
UniversalAnalytics.setup().catch(console.error);

const AppSMLComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <AppIntlProvider>
      <AppInitialEntry>
        <GlobalErrorBoundaryHandler>
          <ReduxLoader>
            <LoginAsGate>
              <NativeAuthTokenHandoff />
              <UserLocaleSync />
              <SignedInHintSync />
              <SessionTokenRefresher />
              <IsOnlineProvider />
              <Toasts />
              <AppUpdateNotice />
              <RealtimeProvider>
                <TRPCLoader>
                  <AppRender>
                    {children}
                    <TRPCDevTools />
                  </AppRender>
                </TRPCLoader>
              </RealtimeProvider>
            </LoginAsGate>
          </ReduxLoader>
        </GlobalErrorBoundaryHandler>
      </AppInitialEntry>
    </AppIntlProvider>
  );
};
export const AppSML = TypedMemo(AppSMLComponent);
